import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faPinterest } from '@fortawesome/free-brands-svg-icons/faPinterest';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faWordpress } from '@fortawesome/free-brands-svg-icons/faWordpress';
import { faYelp } from '@fortawesome/free-brands-svg-icons/faYelp';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faMoneyBillAlt, faSun, IconName } from '@fortawesome/free-regular-svg-icons';
import {
    faBolt,
    faBurn,
    faCar,
    faCaretUp,
    faGraduationCap,
    faHeart,
    faHome,
    faMobileAlt,
    faMotorcycle,
    faPlane,
    faRecycle,
    faRocket,
    faShip,
    faShoppingBag,
    faSolarPanel,
    faStar,
    faTrophy,
    faTv,
    IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { keyBy } from 'lodash';

export const DEFAULT_TRACKER_ICON: IconName = 'caret-up';

export const supportedIcons: IconDefinition[] = [
    faCaretUp,
    faCar,
    faMobileAlt,
    faGraduationCap,
    faMotorcycle,
    // faMoneyBillAlt, -- No longer available
    faPlane,
    faRocket,
    faRecycle,
    faShip,
    faStar,
    faTrophy,
    // faSun, -- No longer available
    faTv,
    faHeart,
    faShoppingBag,
    faHome,
    faBolt,
    faBurn,
    faSolarPanel,
];

export const iconMap = keyBy(supportedIcons, 'iconName');

export interface BrandIcon {
    brandName: string;
    icon: IconDefinition;
}

export type SocialMediaKey =
    | 'facebook'
    | 'instagram'
    | 'linkedIn'
    | 'pinterest'
    | 'twitter'
    | 'yelp'
    | 'youTube'
    | 'wordPress';

export const socialMediaIcons: { [K in SocialMediaKey]: BrandIcon } = {
    facebook: { brandName: 'Facebook', icon: faFacebook },
    instagram: { brandName: 'Instagram', icon: faInstagram },
    linkedIn: { brandName: 'LinkedIn', icon: faLinkedin },
    pinterest: { brandName: 'Pinterest', icon: faPinterest },
    twitter: { brandName: 'X (Twitter)', icon: faXTwitter },
    yelp: { brandName: 'Yelp', icon: faYelp },
    youTube: { brandName: 'YouTube', icon: faYoutube },
    wordPress: { brandName: 'WordPress', icon: faWordpress },
};
